<!--  -->
<template>
  <div class="officialAccount" v-show="show">
    <div class="box">
      <div class="title"><div class="close" @click="changeShow"></div></div>
      <div class="content">
        <h1>请扫码前往公众号完成任务</h1>
        <img class="code" :src="imgUrl" alt="">
        <p>截图保存二维码完成任务</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      imgUrl:''
    };
  },
  computed: {},
  watch: {},
  methods: {
    changeShow() {
      this.show = !this.show;
    },
  },
  created() {},
  mounted() {
    if(window.location.href.indexOf('test')>-1||window.location.href.indexOf('pre')>-1){
      this.imgUrl='https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/test.jpg'
    }else{
      this.imgUrl='https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/officialAccount.jpg'
    }
  },
};
</script>
<style lang="scss" scoped>
.officialAccount {
  position: fixed;
  top: 0;
  left: 0;
     z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: 0.8);

  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 621px;
    height: 690px;
    background: #fff;
    border-radius: 40px;
    transform: translate(-50%, -50%);
    .title {
      position: relative;
      width: 100%;
      height: 291px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/down-app.png');
      background-size: 100%;
      .close {
        position: absolute;
        top: 30px;
        right: 30px;
        z-index: 10;
        width: 40px;
        height: 40px;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/close1.png');
        background-size: 100%;
      }
    }
    .content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      text-align: center;
      h1 {
        padding-top: 125px;
        padding-bottom: 29px;
        color: #333;
        font-weight: 400;
        font-size: 28px;
        text-align: center;
      }
      .code {
        width: 360px;
        height: 360px;
        border-radius: 30px;
      }
      p {
        padding-top: 33px;
        color: #333;
        font-weight: 400;
        font-size: 28px;
      }
    }
  }
}
</style>
